/** Frentes de prospecção do pré-vendas — cada uma tem seu pipeline no CRM. */
export const ORIGENS_PRE_VENDAS = ['inbound', 'outbound'] as const

export type OrigemPreVendas = (typeof ORIGENS_PRE_VENDAS)[number]

export const ROTULO_ORIGEM: Record<OrigemPreVendas, string> = {
  inbound: 'Prospecção Inbound',
  outbound: 'Prospecção Outbound',
}

/** Catálogo fixo — a allow-list de runtime vive no backend. */
export type IndicadorMetaPreVendas =
  | 'r1_agendadas_mes'
  | 'show_rate'
  | 'taxa_agendamento'
  | 'taxa_perda'
  | 'atividades_diarias'

/** Linha da tabela de metas: as editáveis mais as derivadas de outras metas. */
export type IndicadorLinhaMeta = IndicadorMetaPreVendas | 'r1_realizadas_mes'

export type RagPreVendas = 'verde' | 'amarelo' | 'vermelho' | 'pendente'

export interface LinhaSemana {
  sdr: string
  porDia: number[]
  total: number
}

export interface MatrizSemana {
  linhas: LinhaSemana[]
  totalPorDia: number[]
  total: number
}

export interface RelatorioPreVendas {
  dataReferencia: string
  equipe: string[]
  kpisDia: {
    trabalhados: number
    novosLeads: number
    r1Agendadas: number
    taxaAgendamento: number | null
    r1Realizadas: number
    emNutricao: number
    perdidos: number
    taxaPerda: number | null
    noShow: number
    /** Vendas do MÊS com origem na pré-venda. null = pipeline inbound não configurado. */
    vendasInbound: number | null
    /** Valor total (R$) das vendas inbound do mês. null = não configurado. */
    valorVendasInbound: number | null
  }
  semana: {
    dias: string[]
    recebidos: MatrizSemana
    trabalhados: MatrizSemana
    agendadas: MatrizSemana
    realizadas: MatrizSemana
  }
  funilMes: { passos: { rotulo: string; qtd: number; pctDoAnterior: number | null }[] }
  equipeDia: {
    sdr: string
    recebidos: number
    trabalhados: number
    r1Agendadas: number
    r1Realizadas: number
    noShow: number
    perdidos: number
    taxaAgendamento: number | null
  }[]
  funilDia: { etapa: string; qtd: number; pct: number }[]
  metas: {
    indicador: IndicadorLinhaMeta
    rotulo: string
    observacao: string
    /** Meta INDIVIDUAL por SDR. */
    meta: number
    /** Meta individual proporcional ao dia do mês — só nas contagens mensais. */
    metaProporcional: number | null
    porSdr: {
      sdr: string
      realizadoDia: number | null
      realizadoMes: number | null
      rag: RagPreVendas
    }[]
    total: { realizadoDia: number | null; realizadoMes: number | null; rag: RagPreVendas }
  }[]
  pipelineMes: {
    sdrs: string[]
    linhas: { etapa: string; porSdr: number[]; total: number; pct: number }[]
    totalGeral: number
  }
  posR1: { etapa: string; qtd: number; pct: number }[]
  closers: {
    nome: string
    r1Realizadas: number
    propostas: number
    negociacao: number
    fechamento: number
    vendaGanha: number
    total: number
  }[]
  agendaFutura: {
    amanha: number
    seteDias: number
    esteMes: number
    proximoMes: number
    semData: number
  }
}

export interface ResultadoPreVendas {
  configurado: boolean
  pendencia: string | null
  relatorio: RelatorioPreVendas | null
  atualizadoEm: string
  /** 'snapshot' = dia passado servido do congelamento diário do backend. */
  fonte: 'ao-vivo' | 'snapshot'
}

export interface MetaPreVendas {
  indicador: IndicadorMetaPreVendas
  valor: number
}

/** Allow-list de ordenação — espelha a do backend (campo cru é rejeitado lá). */
export type CampoOrdenacaoLeadPreVendas = 'nome' | 'sdr' | 'etapa' | 'criadoEm' | 'atualizadoEm'

export interface LeadPreVendas {
  id: string
  nome: string
  sdr: string
  etapa: string
  criadoEm: string | null
  atualizadoEm: string | null
  url: string
}

export interface ListaLeadsPreVendas {
  configurado: boolean
  pendencia: string | null
  data: LeadPreVendas[]
  page: number
  perPage: number
  total: number
  totalPages: number
  opcoes: { sdrs: string[]; etapas: string[] }
}
